import { defineComponent as _defineComponent } from 'vue'
import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"


export default /*#__PURE__*/_defineComponent({
  __name: 'ApIcon',
  props: {
        icon: String,
    },
  setup(__props) {

const props = __props;

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("i", {
    class: _normalizeClass(["ap-icon", ['ap-icon-' + __props.icon]])
  }, null, 2))
}
}

})